module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"monthly summaries":"Monthly Summaries"},"de":{"monthly summaries":"Monatsübersicht"}}')
  delete Component.options._Ctor
}
